import { config } from './constants';

// TODO: this should be depricated and removed, fix Catiz touch panel and remove this
export const clickButton = (parentId: string, buttonId: string) => {
  const ele: any = document.querySelector(`#${parentId} #${buttonId}`);
  console.log('trying to click', ele, parentId, buttonId);
  if (ele) {
    ele.classList.add('btnClicked');
    setTimeout(() => {
      ele.classList.remove('btnClicked');
      if (ele.click) {
        ele.click();
      }
    }, config.ButtonClickDelay);
  }
};

export const clickButtonObj = (buttonObj: any) => {
  return new Promise<void>((resolve, reject) => {
    buttonObj.classList.add('btnClicked');
    setTimeout(() => {
      buttonObj.classList.remove('btnClicked');
      if (buttonObj.click) {
        buttonObj.click();
      } else {
        var clickEvent = document.createEvent('MouseEvents');
        clickEvent.initEvent('click', true, true);
        buttonObj.dispatchEvent(clickEvent);
      }
      resolve();
    }, config.ButtonClickDelay);
  });
};
